import "core-js/modules/es.array.map.js";
import React from 'react';
import { Modal } from '@applyboard/ui-components';
export var ConditionsModalTitle = /*#__PURE__*/function (ConditionsModalTitle) {
  ConditionsModalTitle["OpenDate"] = "Open Date Conditions";
  ConditionsModalTitle["Deadline"] = "Submission Deadline Conditions";
  return ConditionsModalTitle;
}({});
var generateOpenDateMessage = function generateOpenDateMessage(status, openDate) {
  // eslint-disable-next-line default-case
  switch (status) {
    case 'open':
    case 'waitlist':
    case 'open_conditionally':
      return "The school has started to accept applications for this intake on ".concat(openDate, ".");
    case 'will_open':
    case 'will_open_conditionally':
      return "The school will start accepting applications for this intake on ".concat(openDate, ".");
    case "likely_open":
      return 'The date in which the school starts to accept applications for this intake is still unknown.';
  }

  // not reachable
  throw new Error('Unknown program intake general status');
};
export var IntakeConditionsModal = function IntakeConditionsModal(_ref) {
  var generalClosedConditions = _ref.generalClosedConditions,
    generalOpenedConditions = _ref.generalOpenedConditions,
    generalStatus = _ref.generalStatus,
    modalTitle = _ref.modalTitle,
    openDate = _ref.openDate,
    onClose = _ref.onClose;
  var openDateMessage = modalTitle === ConditionsModalTitle.OpenDate ? generateOpenDateMessage(generalStatus, openDate) : '';
  return /*#__PURE__*/React.createElement(Modal, {
    title: modalTitle,
    open: true,
    handleClose: onClose,
    fullWidth: true,
    maxWidth: "md"
  }, /*#__PURE__*/React.createElement("div", {
    className: "condition-entry"
  }, /*#__PURE__*/React.createElement("ul", null, modalTitle === ConditionsModalTitle.Deadline && (generalClosedConditions === null || generalClosedConditions === void 0 ? void 0 : generalClosedConditions.map(function (line, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, line);
  })), modalTitle === ConditionsModalTitle.OpenDate && (generalOpenedConditions === null || generalOpenedConditions === void 0 ? void 0 : generalOpenedConditions.map(function (line, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, line);
  })), modalTitle === ConditionsModalTitle.OpenDate && /*#__PURE__*/React.createElement("li", null, openDateMessage))));
};